module.exports = __webpack_public_path__ + "img/周口市.41a8ac38.png";